import { Cancel } from "@mui/icons-material";
import { ReactNode } from "react";

export type ChipProps = {
  backgroundColor?: BackgroundColorChipEnum;
  children: ReactNode;
  onDelete?: () => void;
}

export enum BackgroundColorChipEnum {
  GREY_100 = 'bg-grey-100',
}

const Chip = ({ backgroundColor = BackgroundColorChipEnum.GREY_100, children, onDelete }: ChipProps): JSX.Element => {
  return  <div className={`flex justify-center items-center gap-1w m-0 px-2w py-1w w-fit rounded-2xl ${backgroundColor} text-overline`}>
              {children} {onDelete && <Cancel className='text-admin-red-main cursor-pointer' fontSize="small" onClick={onDelete} data-testid='delete-button' />}
          </div>;
};

export default Chip;